/* Haengt den klickbaren Produkt-Freisteller (AgeCare DUO) ins Hero.
   Als JS-Injektion, weil epigreens-hero-split.liquid vom GitHub-Shopify-
   Sync abgelehnt wird und Pseudo-Elemente nicht klickbar sind.
   Der Span-Inhalt verhindert das a:empty{display:none} aus base.css
   und liefert den Linktext fuer Screenreader. */
(function () {
  var hero = document.querySelector('.eg-hero-split');
  if (!hero || hero.querySelector('.eg-hero-product')) return;
  var a = document.createElement('a');
  a.className = 'eg-hero-product';
  a.href = '/products/agecare-duo';
  var label = document.createElement('span');
  label.className = 'visually-hidden';
  label.textContent = 'AgeCare DUO ansehen';
  a.appendChild(label);
  hero.appendChild(a);
})();
